'use strict';

var _ = require('lodash');
var AnalysisChartDataProviderService = function AnalysisChartDataProviderService($filter, $q, retrieverConstants, seasonColorService, svgPatternService, dataRetrieverService, constants, momentService, ConfigurationService, daysOfWeekHelper, prepareInitialDataPointsService, pooledSeasonalityLabelChartDataService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getCabins(market) {
    return pooledSeasonalityLabelChartDataService.getCabins(market);
  }
  function retrieveData(market, visibleData, calendarName, seasonalityType, maxRtp) {
    var m = market.split('-');
    var rqlQuery, params, mode;
    if (visibleData === constants.REVIEW_SEASONALITY_MODES.HISTORICAL) {
      mode = seasonalityType === constants.SEASONALITY_TYPE.POOLED ? retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED : retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL;
      rqlQuery = 'origin==' + m[0] + ';destination==' + m[1] + ';calendarName=="' + calendarName + '"';
    } else {
      params = {
        origin: m[0],
        destination: m[1],
        calendarName: calendarName,
        year: getYear(visibleData),
        maxRtp: maxRtp
      };
      mode = seasonalityType === constants.SEASONALITY_TYPE.POOLED ? retrieverConstants.SEASONALITY_ANALYSIS_CHART_FUTURE_POOLED : retrieverConstants.SEASONALITY_ANALYSIS_CHART_FUTURE;
      rqlQuery = [];
    }
    return dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, mode).setCustomSearchCriteriaRules($q.when(rqlQuery)).setRequestParameters(params).localSortApplied().retrieveComponentData(mode);
  }
  function getLegend(results) {
    if (results && results.length > 0) {
      return _.chain(getCalendarBasedSeasons(results)).map(function (season) {
        return {
          label: season.name,
          fill: seasonColorService.getColor(season.name)
        };
      }).value();
    } else {
      return _.chain(ConfigurationService.getSeasons()).map(function (season) {
        return {
          label: season.name,
          fill: seasonColorService.getColor(season.name)
        };
      }).value();
    }
  }
  function getCalendarBasedSeasons(plottedResults) {
    return _.chain(plottedResults).transform(function (result, r) {
      result.push({
        name: r.season
      });
    }).uniqBy('name').value();
  }
  function getLegendForSpecialEvents(specialEvents) {
    return _.chain(specialEvents).filter(function (event) {
      return event.eventType !== 'Excluded';
    }).transform(function (result, specialEvent) {
      result.push({
        label: specialEvent.eventName,
        fill: seasonColorService.getColor(specialEvent.eventName)
      });
    }).uniqBy('label').value();
  }
  function getDowGroups(dowGroups) {
    return _.map(dowGroups, function (dowGroup) {
      return {
        id: dowGroup.group,
        label: dowGroup.dow.join(',')
      };
    });
  }
  function isArrayWithOneElement(data) {
    return _.isArray(data) && data.length === 1;
  }
  function getYear(visibleData) {
    var year = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    switch (visibleData) {
      case constants.REVIEW_SEASONALITY_MODES.CURRENT:
        return year;
      case constants.REVIEW_SEASONALITY_MODES.CURRENT_PLUS:
        return year + 1;
    }
  }
  function buildAverages(historicalData, targetData) {
    var averages = {};
    _.chain(historicalData.data).uniqBy('weekNumber').groupBy(function (element) {
      return element.season;
    }).forEach(function (value, key) {
      var avg = _.reduce(value, function (sum, n) {
        return sum + n.m1;
      }, 0);
      avg = avg / value.length;
      averages[key] = avg;
    }).value();
    _.forEach(targetData.data, function (value) {
      value.average = averages[value.season];
    });
    return targetData;
  }
  function adjustUmdHeight(result) {
    _.forEach(result.data, function (item) {
      if (!item.isBarStriped) {
        item.m1 = item.average;
      }
    });
    return result;
  }
  function normalizeWeekNo(weekNo) {
    return weekNo === 0 || weekNo === 53 ? 52 : weekNo;
  }
  function transformData(retrievedData, visibleData, filterData) {
    var isHistorical = visibleData === constants.REVIEW_SEASONALITY_MODES.HISTORICAL;
    if (!isArrayWithOneElement(retrievedData)) {
      return {
        data: undefined
      };
    }
    var filter = {
      spos: filterData.spos
    };
    if (filterData.seasonalityType === constants.SEASONALITY_TYPE.POOLED) {
      filter.cabin = filterData.cabin;
    } else if (filterData.isDASeasonality) {
      filter.cabin = filterData.cabin;
      filter.classGroup = filterData.classGroup;
    } else {
      filter.classGroup = filterData.classGroup;
    }
    var dataPointsMap = _.chain(retrievedData[0].outputs).filter(filter).filter(function (entry) {
      return entry.weeklyDataPoints.length > 0 && entry.weeklyDataPoints[0].dowGroup === filterData.dowGroup;
    }).uniqBy('classGroup').reduce(function (filteredDataPoints, entry) {
      if (filterData.woyIndices && isHistorical) {
        _.forEach(entry.weeklyDataPoints, function (dataPoint) {
          var woyIndex = _.get(filterData.woyIndices, dataPoint.week);
          dataPoint.actualWeeklyDataPointValue = woyIndex.originalRemainingUntruncatedResHold || 0;
        });
      }
      return filteredDataPoints.concat(entry.weeklyDataPoints);
    }, []).groupBy('week').value();
    var dataPoints = [];
    if (_.keys(dataPointsMap).length > 0) {
      var dowGroupDefinition = _.find(retrievedData[0].dowGroups, ['group', filterData.dowGroup]);
      if (isHistorical) {
        dataPoints = prepareInitialDataPointsService.prepareInitialDataPoints(filterData.startDate, filterData.endDate, dowGroupDefinition);
      } else {
        var fiftyTwoWeeks = 363;
        var rangeStart = momentService.of(getYear(visibleData), momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.YEAR);
        var rangeEnd = momentService.copy(rangeStart, momentService.FIELD.DEPARTURE_DATE).add(fiftyTwoWeeks, 'day');
        dataPoints = prepareInitialDataPointsService.prepareInitialDataPoints(rangeStart, rangeEnd, dowGroupDefinition);
      }
    }
    var result = _.chain(dataPoints).filter('firstDayOfDowGroup').map(function (d) {
      var m = d.weekNumber !== constants.WOY_53 ? dataPointsMap[d.weekNumber] : dataPointsMap[constants.WOY_52];
      var dowStart = daysOfWeekHelper.dayOfWeekAfter(d.date, d.firstDayOfDowGroup);
      var weeklyDataPointValue;
      if (filterData.seasonalityType === constants.SEASONALITY_TYPE.POOLED && !isHistorical) {
        weeklyDataPointValue = _.chain(m).map(function (dataPoint) {
          return dataPoint.weeklyDataPointValue || 0.0;
        }).sum().value();
      } else {
        weeklyDataPointValue = _.chain(m).map(function (dataPoint) {
          return dataPoint.actualWeeklyDataPointValue || 0.0;
        }).mean().value();
      }
      return {
        season: m[0].season,
        weekNumber: m[0].week,
        normalizedWeek: normalizeWeekNo(m[0].week),
        weekMoment: dowStart,
        m1: weeklyDataPointValue,
        d1: rmMomentFormat(dowStart, 'DATE_USER_SETTINGS'),
        fill: seasonColorService.getColor(m[0].season),
        stackLabel: rmMomentFormat(dowStart, 'DATE_ISO'),
        year: getYear(visibleData),
        isBarStriped: m[0].isDataFromUmd || isHistorical,
        isPooledSeasonality: filterData.seasonalityType === constants.SEASONALITY_TYPE.POOLED,
        average: filterData.seasonalityType === constants.SEASONALITY_TYPE.POOLED ? weeklyDataPointValue : 0
      };
    }).uniqBy('d1').sortBy('realWeekNumber').value();
    return {
      data: result,
      legend: getLegend(result),
      dowGroups: getDowGroups(retrievedData[0].dowGroups),
      savedOverrides: retrievedData[0].seasonalityOverrides
    };
  }
  function prepareLegendWithSpecialEvents(specialEvents, results) {
    return specialEvents ? _.concat(getLegendForSpecialEvents(specialEvents), getLegend(results)) : getLegend(results);
  }
  function applyOverrides(inputData, spos, classGroup, dowGroup, overrides, cabin, seasonalityType) {
    var overridesToApply = _.isEmpty(overrides) ? inputData.savedOverrides : overrides;
    var overrideKey = {
      dowGroup: dowGroup,
      significantPOS: spos
    };
    if (seasonalityType === constants.SEASONALITY_TYPE.POOLED) {
      overrideKey.cabin = cabin;
    } else {
      overrideKey.classGroup = classGroup;
    }
    _.chain(overridesToApply).filter(overrideKey).sortBy('year').reverse().forEach(function (override) {
      var key = {};
      if (override.year) {
        key.year = override.year;
        key.weekNumber = override.weekNo;
      } else {
        key.normalizedWeek = override.weekNo;
      }
      _.chain(inputData.data).filter(key).forEach(function (item) {
        item.season = override.season;
        item.fill = seasonColorService.getColor(override.season);
      }).value();
    }).value();
    return inputData;
  }
  function getData(searchParams) {
    return $q.all([retrieveData(searchParams.market, searchParams.visibleData, searchParams.calendarName, searchParams.seasonalityType, searchParams.maxRtp), retrieveData(searchParams.market, constants.REVIEW_SEASONALITY_MODES.HISTORICAL, searchParams.calendarName, searchParams.seasonalityType, searchParams.maxRtp), pooledSeasonalityLabelChartDataService.getIndexProfileData(searchParams)]).then(function (data) {
      var indexProfile = data[2];
      var woyIndices;
      if (indexProfile && _.isArray(indexProfile) && indexProfile.length > 0) {
        woyIndices = pooledSeasonalityLabelChartDataService.getWoyIndices(indexProfile);
      }
      var filterData = {
        startDate: searchParams.startDate,
        endDate: searchParams.endDate,
        spos: searchParams.spos,
        classGroup: searchParams.classGroup,
        dowGroup: searchParams.dowGroup,
        seasonalityType: searchParams.seasonalityType,
        cabin: searchParams.cabin,
        isDASeasonality: searchParams.isDASeasonality,
        woyIndices: woyIndices
      };
      var targetData = transformData(data[0], searchParams.visibleData, filterData);
      if (searchParams.dowGroup) {
        var historicalData = transformData(data[1], constants.REVIEW_SEASONALITY_MODES.HISTORICAL, filterData);
        applyOverrides(historicalData, searchParams.spos, searchParams.classGroup, searchParams.dowGroup, searchParams.overrides, searchParams.cabin, searchParams.seasonalityType);
        applyOverrides(targetData, searchParams.spos, searchParams.classGroup, searchParams.dowGroup, searchParams.overrides, searchParams.cabin, searchParams.seasonalityType);
        if (searchParams.seasonalityType !== constants.SEASONALITY_TYPE.POOLED) {
          buildAverages(historicalData, targetData);
          adjustUmdHeight(targetData);
        }
      }
      if (searchParams.isDASeasonality) {
        filterData.isDASeasonality = searchParams.isDASeasonality;
      }
      return targetData;
    });
  }
  return {
    getData: getData,
    getLegend: getLegend,
    getCabins: getCabins
  };
};
AnalysisChartDataProviderService.$inject = ['$filter', '$q', 'DataRetrieverConstantsService', 'SeasonColorService', 'SvgPatternService', 'DataRetrieverService', 'SeasonalityConstants', 'MomentService', 'ConfigurationService', 'DaysOfWeekHelper', 'PrepareInitialDataPointsService', 'PooledSeasonalityLabelChartDataService'];
module.exports = AnalysisChartDataProviderService;